export default
    {
        // url: this.$store.state.http.mantto.YYYY,
        cargaDatosGenerador: "/mantenimiento/cargaDatosGenerador",
        cargaDatosMaquinas: "/mantenimiento/cargaDatosMaquinas",
        guardaAseo:"/mantenimiento/guardaAseo",
        guardaEvalExtintores:"/mantenimiento/guardaEvalExtintores",
        guardaGenerador: "/mantenimiento/guardaGenerador",
        guardaIncendio:"/mantenimiento/guardaIncendio",
        guardaMaquinas: "/mantenimiento/guardaMaquinas",
        listAseo:"/mantenimiento/listAseo",
        listEvalExtintores:"/mantenimiento/listEvalExtintores",
        listExtintores:"/mantenimiento/listExtintores",
        listIncendio:"/mantenimiento/listIncendio"
    }
